module.exports = __webpack_public_path__ + "static/media/signin-cover-cutout.437151bc.jpg";